import { render, staticRenderFns } from "./ArticleSupplierPrompt.vue?vue&type=template&id=357da290&scoped=true&"
import script from "./ArticleSupplierPrompt.vue?vue&type=script&lang=js&"
export * from "./ArticleSupplierPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357da290",
  null
  
)

export default component.exports